module.exports = __webpack_public_path__ + "static/media/Honeywell.1f225eba.jpg";